import React, { useEffect } from 'react';
import styles from '../../styles/cards.module.css'
import { comiteEtica } from '../../json/comiteEtica';

const ComiteEtica = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className='container transparencia-container'>
            <div className='row'>
                <div className='col_12'>
                    <div className='transparencia_title'>
                        <h3 className={ styles.title }>
                            Comité de Ética y Prevención de Conflictos de Interés
                        </h3>
                        <hr className='hr-gob'></hr>
                    </div>
                </div>
                {
                    comiteEtica.map((item, index)=>(
                        <div key={ index } className='col-md-3 col-sm-6 col-12'>
                            <div className={styles.container}>
                                <h5 className={styles.name}>
                                    {item.anio}
                                </h5>
                                <hr></hr>
                                {
                                    item.archivos.map((archivo, index) => (
                                        <div key={ index }>
                                            {archivo.urlPrograma && (
                                                <a className={styles.link} href={archivo.urlPrograma} target='_blank' rel='noopener noreferrer'>
                                                    <div className={styles.item}>
                                                        <p className={styles.textLink}>{archivo.name}
                                                            {archivo.programa}
                                                        </p>
                                                        <i className={`icon-file-pdf ${styles.iconLink}`} aria-hidden='true'></i>
                                                    </div>
                                                </a>
                                            )}
                                            {archivo.urlInforme && (
                                                <a className={styles.link} href={archivo.urlInforme} target='_blank' rel='noopener noreferrer'>
                                                    <div className={styles.item}>
                                                        <p className={styles.textLink}>
                                                            {archivo.informe}
                                                        </p>
                                                        <i className={`icon-file-pdf ${styles.iconLink}`} aria-hidden="true"></i>
                                                    </div>
                                                </a>
                                            )}
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default ComiteEtica